import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import MembershipsPage from '@/settings/pages/memberships';

export const Route = createFileRoute('/settings/memberships/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: MembershipsRoute,
  staticData: {
    headerSection: null
  }
});

function MembershipsRoute() {
  return <MembershipsPage/>;
}
